import { Box, Image, Text } from "@chakra-ui/react";

export const DailySpinEndedBanner = () => {
  return (
    <Box
      position="relative"
      w="full"
      h="168px"
      bg="#EDEDEE"
      borderRadius="16px"
      overflow="hidden"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {/* Left decorative wheel */}
      <Image
        src="/assets/daily-spin/bg-wheel-left.svg"
        alt=""
        position="absolute"
        left={0}
        top={0}
        w="305px"
        h="150px"
        objectFit="cover"
      />

      {/* Centered text */}
      <Text
        fontFamily="heading"
        fontWeight="700"
        fontSize="40px"
        lineHeight="48px"
        letterSpacing="-0.8px"
        color="#111"
        textAlign="center"
        zIndex={1}
      >
        Daily Spin has ended
      </Text>

      {/* Right decorative wheel */}
      <Image
        src="/assets/daily-spin/bg-wheel-right.svg"
        alt=""
        position="absolute"
        right={0}
        top="40px"
        w="340px"
        h="128px"
        objectFit="cover"
      />
    </Box>
  );
};
